import { useQuery } from "@tanstack/react-query";
import { api } from "../../../singleton/axios";
import { NotificationPreferences } from "../types";

export const NOTIFICATION_PREFERENCES_QUERY_KEY = ["notification-preferences"] as const;

/** Category × channel switches: the registry's defaults overlaid with the user's own choices. */
export const useNotificationPreferences = () =>
  useQuery({
    queryKey: NOTIFICATION_PREFERENCES_QUERY_KEY,
    queryFn: async (): Promise<NotificationPreferences> => {
      const { data } = await api.get<NotificationPreferences>("/notification-preferences");
      return data;
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
